/** Firestore rules cap theme URLs at 2048 characters. Data URLs do not fit. */

export const THEME_URL_MAX = 2048;

const THEME_URL_KEYS = ["bannerImageUrl", "logoUrl", "coverImageUrl"];

/**
 * URL safe to store on an arena document.
 * Local photos stay in device storage and are not written here.
 * @param {unknown} value
 * @returns {string | null}
 */
export function firestoreThemeUrl(value) {
  if (value == null || value === "") return null;
  const s = String(value).trim();
  if (!s || s.startsWith("data:") || s.length > THEME_URL_MAX) return null;
  return s;
}

/**
 * Copy a write payload with theme fields that rules will accept.
 * @param {Record<string, unknown> | null | undefined} data
 */
export function themeUrlsForFirestore(data) {
  if (!data || typeof data !== "object") return data;
  const next = { ...data };
  for (const key of THEME_URL_KEYS) {
    if (!(key in next)) continue;
    next[key] = firestoreThemeUrl(next[key]);
  }
  return next;
}
